// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__23AZ3","col":"styles_col__CtevD","fulfillmentStatus":"styles_fulfillmentStatus__15_Fw","emailCol":"styles_emailCol__1L3J-"};